import React from 'react';
import { Smiley, SmileyMeh, SmileySad, Sun, Moon } from 'phosphor-react';
import { StepReaction } from '../../types/enums';

interface ReactionOption {
  value: StepReaction;
  icon: React.ReactNode;
  label: string;
  activeClass: string;
}

const REACTIONS: ReactionOption[] = [
  {
    value: StepReaction.GREAT,
    icon: <Smiley className="w-4 h-4" />,
    label: 'Ótimo',
    activeClass: 'border-sage-400 bg-sage-50 dark:bg-sage-900/30 text-sage-600 dark:text-sage-400',
  },
  {
    value: StepReaction.NEUTRAL,
    icon: <SmileyMeh className="w-4 h-4" />,
    label: 'Neutro',
    activeClass: 'border-nude-300 bg-white dark:bg-gray-700 text-nude-600 dark:text-gray-300',
  },
  {
    value: StepReaction.IRRITATED,
    icon: <SmileySad className="w-4 h-4" />,
    label: 'Irritou',
    activeClass: 'border-red-300 bg-red-50 dark:bg-red-900/30 text-red-500 dark:text-red-400',
  },
];

interface RoutineStep {
  id: string;
  period?: string;
  displayName: string;
}

interface StepReactionPickerProps {
  routineSteps: RoutineStep[];
  reactions: Record<string, StepReaction | null>;
  onReactionChange: (stepId: string, reaction: string) => void;
}

export default function StepReactionPicker({ routineSteps, reactions, onReactionChange }: StepReactionPickerProps) {
  if (routineSteps.length === 0) return null;

  return (
    <div className="flex flex-col gap-3">
      <label className="text-xs font-medium text-nude-700 dark:text-gray-400 tracking-wide uppercase">
        Reação da pele por etapa
      </label>
      <div className="stagger flex flex-col gap-2">
        {routineSteps.map((step) => {
          const current = reactions[step.id];
          return (
            <div
              key={step.id}
              className="bg-nude-50 dark:bg-gray-750 border border-nude-100 dark:border-gray-700 rounded-xl p-3 flex flex-col gap-2"
            >
              <div className="flex items-center gap-2">
                <span className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide text-nude-400 dark:text-gray-500">
                  {step.period === 'MORNING' ? (
                    <><Sun className="w-3 h-3" /> Manhã</>
                  ) : (
                    <><Moon className="w-3 h-3" /> Noite</>
                  )}
                </span>
                <p className="text-sm font-medium text-gray-700 dark:text-gray-200 truncate">
                  {step.displayName}
                </p>
              </div>
              <div className="flex gap-2">
                {REACTIONS.map(({ value, icon, label, activeClass }) => (
                  <button
                    key={value}
                    type="button"
                    onClick={() => onReactionChange(step.id, value)}
                    className={`flex-1 flex flex-col items-center gap-1 py-2 rounded-xl border-2 text-[11px] font-semibold transition-colors active:scale-[0.97] ${
                      current === value
                        ? activeClass
                        : 'border-transparent bg-nude-50 dark:bg-gray-700 text-nude-400 dark:text-gray-500 hover:bg-nude-100 dark:hover:bg-gray-600'
                    }`}
                  >
                    {icon}
                    {label}
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
